import { LightningColorArray, LightningSearchTypeEnum } from "@/util/cosntants";
import { IGetLocationsResModel } from "@/util/http/Lightning/responseType";

export const handleLocationSearchRequest = (locationNameOrCoordinate: string, selectedLocationItem?:IWeeviltrakSearchLocationsResModel ):[number,number,string?]=>{
    // 正则匹配类似 "0,0" 或 "1,2" 的纯数字字符串
    const trimmed = locationNameOrCoordinate.trim();
    const match = trimmed.match(/^(-?\d+\.?\d*),\s*(-?\d+\.?\d*)$/);
    let tmpLng = 0;
    let tmpLat = 0;
    let locationName = "";
    if (match) {
        tmpLat = parseFloat(match[1]);
        tmpLng = parseFloat(match[2]);
        locationName = `${tmpLat},${tmpLng}`;
    }

    // 否则返回原字符串
    else if(selectedLocationItem ){
        tmpLat = selectedLocationItem?.latitude;
        tmpLng = selectedLocationItem?.longitude;
        locationName = selectedLocationItem?.address;
    }
    return [tmpLng, tmpLat,locationName];
};

export interface LatLng {
  lat: number;
  lng: number;
}

/**
 * 根据中心点、半径和点的数量，计算圆周上均匀分布的坐标点。
 * @param centerLat 圆心纬度
 * @param centerLng 圆心经度
 * @param radiusKm 圆的半径，单位为千米
 * @param numberOfPoints 要生成的点的数量，默认为12
 * @returns 包含圆周上坐标点的数组
 */
export const getPointsOnCircle = (
    centerLat: number,
    centerLng: number,
    radiusKm: number,
    numberOfPoints = 12
): LatLng[] => {
    const points: LatLng[] = [];
    const EARTH_RADIUS_KM = 6371; // 地球平均半径，单位：千米

    // 将中心点的经纬度转换为弧度
    const centerLatRad = (centerLat * Math.PI) / 180;
    const centerLngRad = (centerLng * Math.PI) / 180;

    // 计算每个点之间的角度间隔（弧度）
    const angleStep = (2 * Math.PI) / numberOfPoints;

    for (let i = 0; i < numberOfPoints; i++) {
        const angle = i * angleStep;

        // 计算相对于中心点的纬度变化量
        // dLat = (radius / EarthRadius) * cos(angle)
        const latDeltaRad = (radiusKm / EARTH_RADIUS_KM) * Math.cos(angle);

        // 计算相对于中心点的经度变化量
        // dLng = (radius / (EarthRadius * cos(centerLat))) * sin(angle)
        // 注意：这里的经度变化需要考虑纬度对圆周长度的影响
        const lngDeltaRad = (radiusKm / (EARTH_RADIUS_KM * Math.cos(centerLatRad))) * Math.sin(angle);

        // 计算新点的纬度（弧度）
        const newLatRad = centerLatRad + latDeltaRad;

        // 计算新点的经度（弧度）
        const newLngRad = centerLngRad + lngDeltaRad;

        // 将弧度转换回经纬度（度）
        const newLat = (newLatRad * 180) / Math.PI;
        const newLng = (newLngRad * 180) / Math.PI;

        points.push({ lat: newLat, lng: newLng });
    }

    return points;
};

// for color
export const firstStrikeTilteArray = [
    "0.00-10.00",
    "10.00-15.00",
    "15.00-20.00",
    "20.00-25.00",
    "25.00-30.00",
    "30.00-35.00",
    "35.00-40.00",
    "40.00-45.00",
    "45.00-50.00",
    "50.00-55.00",
    "55.00-60.00",
];
export const FIRST_STRIKE_COLORS = [
    { range: "0.00-10.00" , color: "#8B0000" },
    { range: "10.00-15.00", color: "#B22222" },
    { range: "15.00-20.00", color: "#CD5C5C" },
    { range: "20.00-25.00", color: "#FF6347" },
    { range: "25.00-30.00", color: "#FF8C00" },
    { range: "30.00-35.00", color: "#FFA500" },
    { range: "35.00-40.00", color: "#FFD700" },
    { range: "40.00-45.00", color: "#FFFF00" },
    { range: "45.00-50.00", color: "#ADFF2F" },
    { range: "50.00-55.00", color: "#7FFF00" },
    { range: "55.00-60.00", color: "#32CD32" },
];
export const PROBABILITY_COLORS = [
    { range: "0.05-0.10",color: "#C1E1C1" }, // 浅绿（加深）
    { range: "0.10-0.15",color: "#A9D18E" }, // 淡绿（加深）
    { range: "0.15-0.20",color: "#7CB342" }, // 中绿
    { range: "0.20-0.25",color: "#66BB6A" }, // 翠绿
    { range: "0.25-0.30",color: "#558B2F" }, // 深绿
    { range: "0.30-0.35",color: "#FFFF00" }, // 黄
    { range: "0.35-0.40",color: "#FFD740" }, // 浅橙黄（加深）
    { range: "0.40-0.45",color: "#FFC107" }, // 琥珀色
    { range: "0.45-0.50",color: "#FFA726" }, // 浅橙
    { range: "0.50-0.55",color: "#FF9800" }, // 橙
    { range: "0.55-0.60",color: "#FF7043" }, // 浅红橙
    { range: "0.60-0.65",color: "#FF5722" }, // 橙红
    { range: "0.65-0.70",color: "#F44336" }, // 红
    { range: "0.70-0.75",color: "#E53935" }, // 深红
    { range: "0.75-0.80",color: "#D32F2F" }, // 深暗红
    { range: "0.80-0.85",color: "#B71C1C" }, // 暗红
    { range: "0.85-0.90",color: "#990000" }, // 褐红
    { range: "0.90-0.95",color: "#7F0000" }, // 深褐红
    { range: "0.95-1.00", color: "#610B0B" }, // 近黑红
];

export const COLOR_ALL_RISK = LightningColorArray.Risk; // 例如：深红色
export const COLOR_RISK = "#FFC107"; // 例如：橙色

/**
 * 根据类型和字符串表示的范围获取对应的颜色。
 * @param type 'FirstStrike' | 'Probability'
 * @param valueStr 字符串形式的范围，例如 "0.05-0.10"
 * @returns 对应的颜色字符串，如果没有匹配则返回默认颜色 #CCCCCC
 */
// export const getColorForValue = (type: LightningSearchTypeEnum.FIRSTSTRIKE | LightningSearchTypeEnum.PROBABILITY, valueStr: string): string => {
//     const colorMap = type === LightningSearchTypeEnum.FIRSTSTRIKE ? FIRST_STRIKE_COLORS : PROBABILITY_COLORS;

//     for (const { range, color } of colorMap) {
//         if (range === valueStr) { // 直接字符串匹配
//             return color;
//         }
//     }

//     // 如果没有匹配的区间，返回一个默认颜色
//     return "#CCCCCC"; // 灰色
// };


// commone func
export const slefSleep = (ms: number) => {
    return new Promise(resolve => setTimeout(resolve, ms));
};
export const blockForOneSecond = async () => {
    await slefSleep(1000); // 模拟阻塞1秒
};

export const ProbilityArray = [
    "0.05-0.10",
    "0.10-0.15",
    "0.15-0.20",
    "0.20-0.25",
    "0.25-0.30",
    "0.30-0.35",
    "0.35-0.40",
    "0.40-0.45",
    "0.45-0.50",
    "0.50-0.55",
    "0.55-0.60",
    "0.60-0.65",
    "0.65-0.70",
    "0.70-0.75",
    "0.75-0.80",
    "0.80-0.85",
    "0.85-0.90",
    "0.90-0.95",
    "0.95-1.00",
];
export const ReversedProbabilityArray = [
    "0.95-1.00",
    "0.90-0.95",
    "0.85-0.90",
    "0.80-0.85",
    "0.75-0.80",
    "0.70-0.75",
    "0.65-0.70",
    "0.60-0.65",
    "0.55-0.60",
    "0.50-0.55",
    "0.45-0.50",
    "0.40-0.45",
    "0.35-0.40",
    "0.30-0.35",
    "0.25-0.30",
    "0.20-0.25",
    "0.15-0.20",
    "0.10-0.15",
    "0.05-0.10",
];


// for weeviltrak api
/**
 * Color utilities for WeevilTrak Map Component
 */



/**
 * Color range interface
 */
export interface ColorRange {
    min: number;
    max: number;
    color: string;
}

/**
 * Color Scale - Blue gradient
 * Value ranges: 20-30, 30-40, 40-50, 50-60, 60-70, 70-80
 */
export const COLOR_SCALE: ColorRange[] = [
    { min: 20, max: 30, color: "rgb(222,235,247)" }, // 20 <= value < 30
    { min: 30, max: 40, color: "rgb(158,202,225)" }, // 30 <= value < 40
    { min: 40, max: 50, color: "rgb(107,174,214)" }, // 40 <= value < 50
    { min: 50, max: 60, color: "rgb(66,146,198)" }, // 50 <= value < 60
    { min: 60, max: 70, color: "rgb(33,113,181)" }, // 60 <= value < 70
    { min: 70, max: 80, color: "rgb(8,81,156)" }, // 70 <= value <= 80
];

/**
 * Map prediction value to color from COLOR_SCALE
 * @param value - The predicted days value (should be between 20-80)
 * @returns The color string for the given value
 */
export const getColorForValue = (value: number): string => {
    // Clamp value to valid range
    const clampedValue = Math.max(20, Math.min(80, value));

    // Find the matching color range
    for (const range of COLOR_SCALE) {
        if (clampedValue >= range.min && clampedValue < range.max) {
            return range.color;
        }
    }

    // Handle the edge case for value = 80 (last range includes max)
    if (clampedValue === 80) {
        return COLOR_SCALE[COLOR_SCALE.length - 1].color;
    }

    return COLOR_SCALE[0].color;
};



/**
 * Map utility functions for WeevilTrak Map Component
 */

// import type { GeoJsonData, PradictionJsonData, PredictionData } from "../types";
import { GeoJsonData, IGetWeevilTrakResModel, IPredictionDataModel, IWeeviltrakSearchLocationsResModel } from "@/util/http/WeevilTrak/responseType";

/**
 * Convert GeoJSON coordinates to Google Maps LatLng format
 */
export const geoJsonCoordsToLatLng = (coordinates: number[][]): Array<{ lat: number; lng: number }> => {
    return coordinates.map(coord => ({
        lat: coord[1],
        lng: coord[0]
    }));
};

/**
 * Get prediction value for a location
 */
export const getValue = (location: string, predictionData: IPredictionDataModel[]): number => {
    const data = predictionData?.find(d => d.location === location);
    return data?.predictedDays || 0;
};

/**
 * Convert pradiction.json data to GeoJSON FeatureCollection format
 */
export const convertPradictionToGeoJson = (data: IGetWeevilTrakResModel): GeoJsonData => {
    const features: GeoJsonData["features"] = [];

    data?.locations?.forEach(prediction => {
        const { longitude, latitude } = prediction;
        const predictedDays = prediction?.predictions?.[0]?.predictedDays ?? 0;

        const placeId = `${latitude}_${longitude}`;

        const offset = 0.05;
        const coordinates = [
            [longitude - offset, latitude + offset],
            [longitude + offset, latitude + offset],
            [longitude + offset, latitude - offset],
            [longitude - offset, latitude - offset],
            [longitude - offset, latitude + offset]
        ];

        features.push({
            type: "Feature",
            properties: {
                place_id: placeId,
                center_lat: latitude,
                center_lon: longitude,
                predicted_days: predictedDays,
                prediction_date: prediction?.predictions?.[0]?.predictionDate,
                stage: prediction?.predictions?.[0]?.stage,
                stage_id: prediction?.predictions?.[0]?.stageId,
                predicted_stage_date: prediction?.predictions?.[0]?.predictedStageDate
            },
            geometry: {
                type: "Polygon",
                coordinates: [coordinates]
            }
        });
    });

    return {
        type: "FeatureCollection",
        features
    };
};

/**
 * Calculate map center from prediction data
 */
export const calculateMapCenter = (data: IGetWeevilTrakResModel): { lat: number; lng: number } => {
    if (data?.locations?.length === 0) {
        return { lat: 34.1, lng: -78.3 };
    }

    const sum = data?.locations?.reduce(
        (acc, p) => ({
            lat: acc.lat + p.latitude,
            lng: acc.lng + p.longitude
        }),
        { lat: 0, lng: 0 }
    );

    return {
        lat: sum?.lat / (data?.locations?.length) || 1,
        lng: sum?.lng / (data?.locations?.length) || 1
    };
};




// legends color
// 渐变的关键颜色点
//const GRADIENT_COLORS = [
//    { percent: 0, color: [26, 35, 126] }, // #1A237E
//    { percent: 0.178, color: [0, 151, 167] }, // #0097A7
//    { percent: 0.344, color: [102, 187, 106] }, // #66BB6A
//   { percent: 0.511, color: [255, 238, 88] }, // #FFEE58
//    { percent: 0.678, color: [251, 140, 0] }, // #FB8C00
//    { percent: 1, color: [183, 28, 28] }, // #B71C1C
//];
const GRADIENT_COLORS = [
    { percent: 0, color: [183, 28, 28] }, // #B71C1C
    { percent: 0.178, color: [251, 140, 0] }, // #FB8C00
    { percent: 0.344, color: [255, 238, 88] }, // #FFEE58
    { percent: 0.511, color: [102, 187, 106] }, // #66BB6A
    { percent: 0.678, color: [0, 151, 167] }, // #0097A7
    { percent: 1, color: [26, 35, 126] }, // #1A237E
];
// const GRADIENT_COLORS = [
//     { percent: 0, color: [255, 255, 255] }, // 最浅
//     { percent: 0.178, color: [210, 220, 231] },
//     { percent: 0.344, color: [169, 188, 208] },
//     { percent: 0.511, color: [127, 155, 186] },
//     { percent: 0.678, color: [85, 122, 163] },
//     { percent: 0.844, color: [44, 90, 141] },
//     { percent: 1, color: [5, 60, 120] } // 最深
// ];

// 线性插值
export const lerp = (start, end, t) => {
    return start + (end - start) * t;
};

// 获取渐变颜色
export const getGradientColor = (value) => {
    // 如果值超过 90，返回最深颜色
    if (value > 90) {
        return { r: 8, g: 81, b: 156 };
    }
    if (value < 0) {
        return { r: 222, g: 235, b: 247 };
    }

    // value 从 0 到 90
    const t = value / 90; // 归一化到 0-1

    // 找到 t 所在的区间
    for (let i = 0; i < GRADIENT_COLORS.length - 1; i++) {
        const start = GRADIENT_COLORS[i];
        const end = GRADIENT_COLORS[i + 1];

        if (t >= start.percent && t <= end.percent) {
            // 计算在当前区间的插值比例
            const localT = (t - start.percent) / (end.percent - start.percent);

            const r = Math.round(lerp(start.color[0], end.color[0], localT));
            const g = Math.round(lerp(start.color[1], end.color[1], localT));
            const b = Math.round(lerp(start.color[2], end.color[2], localT));

            return { r, g, b };
        }
    }

    return { r: 8, g: 81, b: 156 };
};

// RGB 转字符串
export const rgbToString = (r, g, b) => {
    return `rgb(${r}, ${g}, ${b})`;
};




function clamp01(x) {
    return Math.max(0, Math.min(1, x));
}

// HSL -> RGB（h: 0-360, s/l: 0-100）
function hslToRgb(h, s, l) {
    // 确保 h 在 0-360 之间
    const hh = ((h % 360) + 360) % 360;
    const ss = Math.max(0, Math.min(100, s)) / 100;
    const ll = Math.max(0, Math.min(100, l)) / 100;

    const c = (1 - Math.abs(2 * ll - 1)) * ss;
    const x = c * (1 - Math.abs(((hh / 60) % 2) - 1));
    const m = ll - c / 2;

    let r1 = 0, g1 = 0, b1 = 0;
    if (hh < 60) {
        r1 = c; g1 = x; b1 = 0;
    } else if (hh < 120) {
        r1 = x; g1 = c; b1 = 0;
    } else if (hh < 180) {
        r1 = 0; g1 = c; b1 = x;
    } else if (hh < 240) {
        r1 = 0; g1 = x; b1 = c;
    } else if (hh < 300) {
        r1 = x; g1 = 0; b1 = c;
    } else {
        r1 = c; g1 = 0; b1 = x;
    }

    const r = Math.round((r1 + m) * 255);
    const g = Math.round((g1 + m) * 255);
    const b = Math.round((b1 + m) * 255);
    return { r, g, b };
}


// 分段获取颜色配置
// export const getGradientColor = (value) => {
//     const v = Math.max(0, Math.min(90, value));

//     let h, s, l;

//     // 0-10 重点优化：
//     // 用户希望能明显看出 0-10 之间的差异，同时前20不要太深。
//     // 策略：
//     // 1. 起始亮度拉高 (L=98)，10的时候降到 L=82。这 16% 的亮度差分摊到 10 个格子上，每格约 1.5%，肉眼可辨。
//     // 2. 色相在此区间快速偏转 (220->180)，从纯蓝偏向青色，增加色彩差异。

//     if (v <= 10) {
//         const t = v / 10;
//         // 蓝(220) -> 青(180)
//         // 亮度 98 -> 82 (差异明显但仍然是浅色)
//         h = lerp(220, 180, t);
//         s = 88;
//         l = lerp(98, 82, t);
//     }
//     else if (v <= 75) {
//         // 10-75: 衔接上面的终点，过渡到原本的深红
//         // 青(180) -> 红(10)
//         // 亮度 82 -> 25 (深色)
//         const t = (v - 10) / (75 - 10);
//         h = lerp(180, 10, t);
//         s = 88;
//         l = lerp(82, 25, t);
//     }
//     else {
//         // 75-90: 最后的深色延伸
//         // 红(10) -> 黑红(360/0)
//         const t = (v - 75) / (90 - 75);
//         h = lerp(10, 0, t); // 这里的 0 等同于 360
//         s = lerp(88, 100, t);
//         l = lerp(25, 12, t);
//     }

//     return hslToRgb(h, s, l);
// };



export const allNotBelongUSAStagesName = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Louisiana",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Mexico",
    "North Dakota",
    "Oklahoma",
    "Oregon",
    "South Carolina",
    "South Dakota",
    "Texas",
    "Utah",
    "Washington",
    "Wisconsin",
    "Wyoming"
];

export const specialStagesName = [
    "Kentucky",
    "Maine",
    "Maryland",
    "Massachusetts",
    "New Hampshire",
    "New Jersey",
    "Tennessee",
    "Vermont",
    "Virginia",
    "West Virginia",
    "Connecticut",
    "Delaware",
    "New York",
    "North Carolina",
    "Ohio",
    "Pennsylvania",
    "Rhode Island",
];

export const specialCAStagesName = [
    "Ontario",
    "Quebec"
];

export const notSpecialCAStagesName = [
    "British Columbia",
    "Alberta",
    "Saskatchewan",
    "Manitoba",
    "Nova Scotia",
    "New Brunswick",
    "Newfoundland and Labrador",
    "Prince Edward Island",

    "Yukon Territory",
    "Northwest Territories",
    "Nunavut"
];
